import { useQuery } from "react-query";
import { EventParticipationAPI } from "api/eventParticipation";
import { EVENT_PARTICIPATION } from "helpers/constants";

export default function useEventParticipationForCompetitionEventWithFeedback(
  competitionEventId
) {
  return useQuery(
    [EVENT_PARTICIPATION, competitionEventId, "feedback"],
    () =>
      EventParticipationAPI.getAllForCompetitionEventWithFeedback(
        competitionEventId
      ),
    {
      enabled: !!competitionEventId,
    }
  );
}
